import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  standalone: false,
  selector: 'app-observation-video-dialog',
  templateUrl: './observation-video-dialog.component.html',
  styleUrls: ['./observation-video-dialog.component.scss']
})
export class ObservationVideoDialogComponent {

  constructor(public dialogRef: MatDialogRef<ObservationVideoDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { filename: string, videoUrl: string }) { }

  openInNewTab(): void {
    window.open(this.data.videoUrl, '_blank');
  }

  onClose(): void {
    this.dialogRef.close();
  }
}
